import { render, staticRenderFns } from "./predictionpoints.vue?vue&type=template&id=6ec41fb6&"
import script from "./predictionpoints.vue?vue&type=script&lang=js&"
export * from "./predictionpoints.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./predictionpoints.vue?vue&type=style&index=1&id=6ec41fb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports